/**
 * Copyright (c) 2024, Mint Metrics Pty Ltd All rights reserved. BSD 3-Clause License. https://github.com/mint-metrics/mojito/blob/master/LICENSE
 * Copyright (c) 2010, James Yu. https://github.com/jamesyu/cohorts/blob/master/LICENSE
 * Copyright (c) 2005-2017, JS Foundation All rights reserved. https://dojotoolkit.org/license.html
 * Copyright (c) 2011 Sebastian Tschan, https://blueimp.net
 */

(function () {
    var sharedObject = {
        conf: {
            parms: {
                regExps: [
                    /^\/collections\/baby-prams-online(\/.*)?$/,
                    /\/collections\/single-pram/,
                    /\/collections\/double-pram/,
                    /\/collections\/baby-travel-pram/,
                    /\/collections\/baby-pram-accessories/
                ]
            },
            car: {
                regExps: [
                    /^\/collections\/car(\/.*)?$/,
                    /\/collections\/car-accessories/,
                    /\/collections\/car-safety-capsules/,
                    /\/collections\/car-safety-convertible-car-seats/
                ]
            },
            nursery: {
                regExps: [
                    /^\/collections\/nursery(\/.*)?$/,
                    /\/collections\/newborn-baby-swaddle-blankets/,
                    /\/collections\/nursery-bouncers/,
                    /\/collections\/nursery-change-table-accessories/,
                    /\/collections\/baby-cot-online/,
                    /\/collections\/nursery-cot-accessories/,
                    /\/collections\/nursery-nursery-decor/,
                    /\/collections\/monitors/,
                    /\/collections\/nursery-sleeping-aid/
                ]
            },
            playtime: {
                regExps: [
                    /^\/collections\/playtime(\/.*)?$/,
                    /\/collections\/play-time-plush-toy/,
                    /\/collections\/books/,
                    /\/collections\/baby-play-gym-toys-online/,
                    /\/collections\/buy-baby-pen/,
                    /\/collections\/baby-teething-toys-online/,
                    /\/collections\/wooden-toys/
                ]
            },
            feeding: {
                regExps: [
                    /^\/collections\/baby-nursing-feeding(\/.*)?$/,
                    /\/collections\/nursing-and-feeding-bibs/,
                    /\/collections\/newborn-baby-bottles-for-breastfed-babies/,
                    /\/collections\/nursing-breastfeeding-pump/,
                    /\/collections\/feeding-cleaning/,
                    /\/collections\/baby-food-processing-machines/,
                    /\/collections\/nursing-and-feeding-formula-dispenser/,
                    /\/collections\/nursing-and-feeding-high-chairs-boosters/,
                    /\/collections\/nursing-and-feeding-soothers/,
                    /\/collections\/baby-sterilisers-machine-sale/,
                    /\/collections\/best-baby-tableware/
                ]
            },
            bath: {
                regExps: [
                    /^\/collections\/bath(\/.*)?$/,
                    /\/collections\/baby-care/,
                    /\/collections\/bath-bath-tub-stand/,
                    /\/collections\/bath-towels-and-accessories/,
                    /\/collections\/bath-laundry/,
                    /\/collections\/nappies/,
                    /\/collections\/potty-seat/,
                    /\/collections\/bath-oral-care/,
                    /\/collections\/skin-care-body-wash/
                ]
            },
            clothing: {
                regExps: [
                    /^\/collections\/baby-clothes(\/.*)?$/,
                    /\/collections\/onesie/,
                    /\/collections\/bodysuit/,
                    /\/collections\/pants-leggings/,
                    /\/collections\/dresses/,
                    /\/collections\/hats-beanies/,
                    /\/collections\/clothing-sets-packs/
                ]
            },
            images: {

            }
        },
        match: function () {
            var pathname = location.pathname,
                conf = this.conf,
                confItem,
                regExps,
                i, c;

            for (var key in conf) {
                confItem = conf[key];
                regExps = confItem.regExps;
                if (!regExps) {
                    continue;
                }

                for (i=0, c=regExps.length; i<c; i++) {
                    if (regExps[i].test(pathname)) {
                        this.matchedItem = confItem;
                        return confItem;
                    }
                }
            }

            return null;
        },
        transform: function (forControl) {
            document.documentElement.classList.add('w51');
            if (forControl && !this.match()) {
                return;
            }

            var isTouch = 'ontouchstart' in document;
            var isDrag = false;
            var collectionFilterNode = document.querySelector('.collection-grid__wrapper .collection-filter');
            if (!collectionFilterNode) {
                return;
            }

            var debounce = function (fn) {
                var timer;
                return function (event) {
                    if (timer) {
                        clearTimeout(timer);
                    }
                    timer = setTimeout(fn, 100, event);
                };
            };

            var container = document.createElement('div');
            container.className = 'filter-container';
            container.innerHTML = '\
            <div class="scroll-holder"><div class="inner"></div></div>\
            <div class="arrow-left"><i class="fa fa-angle-left"></i></div>\
            <div class="arrow-right"><i class="fa fa-angle-right"></i></div>';

            collectionFilterNode.insertAdjacentElement('beforebegin', container);
            container.classList.add('use-image');

            if (isTouch) {
                container.classList.add('has-touch');
            }

            if (!forControl) {
                container.classList.add('for-treatment');
            }

            var onFilterNodeClick = function (e) {
                if (isDrag) {
                    e.preventDefault();
                    e.stopPropagation();
                    isDrag = false;
                    return;
                }

                var itemNode = e.target.closest('a');

                if (itemNode.classList.contains('selected')) {
                    var thumbLinks = document.querySelectorAll('nav.breadcrumb ul li a');
                    if (thumbLinks.length > 1) {
                        e.preventDefault();
                        e.stopPropagation();

                        thumbLinks[thumbLinks.length -2].click();
                    }
                }

                itemNode.classList.add('selected');


            };

            var onFilgerNodeDragStart = function () {
                return false;
            };

            var shouldTransformItem = function (itemNode) {
                if (itemNode.classList.contains('js-no-transition')) {
                    return false;
                }

                if (itemNode.parentNode.querySelector('ul.tag-list')) {
                    return false;
                }

                var ulNode = itemNode.closest('ul');
                if (ulNode.previousElementSibling && ulNode.previousElementSibling.tagName === 'A' && ulNode.previousElementSibling.textContent.trim() === 'Brands') {
                    return false;
                }

                return true;
            };

            var arrowLeft = container.querySelector('.arrow-left'),
                arrowRight = container.querySelector('.arrow-right'),
                scrollHolder = container.querySelector('.scroll-holder'),
                filterHolder = container.querySelector('.inner'),
                tagList = document.querySelectorAll('.collection-sidebar ul.tag-list li a'),
                tagNode,
                filterNode,
                renderedFilters = [],
                image,
                i, c;

            for (i=0, c=tagList.length; i<c; i++) {
                tagNode = tagList[i];

                image = this.conf.images[tagNode.textContent.trim()];
                if (!image && forControl) {
                    continue;
                }

                if (!forControl && !shouldTransformItem(tagNode)) {
                    continue;
                }

                filterNode = document.createElement('a');
                filterNode.href = tagNode.href;
                filterNode.filterName = tagNode.textContent.trim();
                renderedFilters.push(filterNode.filterName);
                filterNode.ondragstart = onFilgerNodeDragStart;

                filterNode.classList.add('image');
                if (image) {
                    filterNode.innerHTML = '<img src="'+image+'"><span>' + tagNode.textContent + '</span><span class="clear-icon">&times;</span>';
                } else {
                    filterNode.innerHTML = '<span class="placeholder"></span><span>' + tagNode.textContent + '</span><span class="clear-icon">&times;</span>';
                }

                if (tagNode.parentNode.classList.contains('tag--active')) {
                    filterNode.classList.add('selected');
                    filterHolder.insertAdjacentElement('afterbegin', filterNode);
                } else {
                    filterHolder.insertAdjacentElement('beforeend', filterNode);
                }

                filterNode.addEventListener('click', onFilterNodeClick);
            }

            if (filterHolder.children.length) {
                container.classList.add('show');
            }

            // see more link
            filterNode = document.createElement('a');
            filterNode.href = '#';
            filterNode.className = 'see-more';
            filterNode.innerHTML = 'See more';
            filterHolder.insertAdjacentElement('beforeend', filterNode);
            filterNode.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                if (filterHolder.children.length > 11 && !container.classList.contains('show-more')) {
                    container.classList.add('show-more');
                    checkScrollStatus();
                    return;
                }

                var drawerBtn = document.querySelector('button.js-drawer-open-collection-filters');
                if (drawerBtn) {
                    drawerBtn.click();
                }
            });
            filterNode.ondragstart = function () { return false; };



            var checkScrollStatus = function () {
                if (scrollHolder.scrollWidth === scrollHolder.clientWidth) {
                    arrowLeft.style.display = 'none';
                    arrowRight.style.display = 'none';
                    return;
                }

                if (scrollHolder.scrollLeft > 0) {
                    arrowLeft.style.display = 'block';

                    if (Math.ceil(scrollHolder.clientWidth + scrollHolder.scrollLeft) >= scrollHolder.scrollWidth) {
                        arrowRight.style.display = 'none';
                    } else {
                        arrowRight.style.display = 'block';
                    }
                } else {
                    arrowRight.style.display = 'block';
                    arrowLeft.style.display = 'none';
                }
            };

            checkScrollStatus();

            arrowLeft.addEventListener('click', function () {
                var x = scrollHolder.scrollLeft - Math.floor(scrollHolder.clientWidth*0.8);
                if (x < 0) {
                    x = 0;
                }

                jQuery(scrollHolder).stop().animate(
                    {
                        scrollLeft: x
                    },
                    500,
                    'swing',
                    checkScrollStatus
                );
            });

            arrowRight.addEventListener('click', function () {
                var x = scrollHolder.scrollLeft + Math.floor(container.clientWidth*0.8),
                    fullWidth = scrollHolder.scrollWidth - scrollHolder.clientWidth;
                if (x >= fullWidth) {
                    x = fullWidth;
                }

                jQuery(scrollHolder).stop().animate(
                    {
                        scrollLeft: x
                    },
                    500,
                    'swing',
                    checkScrollStatus
                );
            });

            window.addEventListener('resize', debounce(function () {
                scrollHolder.scrollLeft = 0;
                checkScrollStatus();
            }));

            var pos = { left: 0, x: 0 };

            var onMouseDown = function (e) {
                pos.left = scrollHolder.scrollLeft;
                pos.x = e.clientX;

                document.addEventListener('mousemove', mouseMove);
                document.addEventListener('mouseup', onMouseUp);
            };

            var mouseMove = function (e) {
                var dx = e.clientX - pos.x;
                scrollHolder.scrollLeft = pos.left - dx;
                checkScrollStatus();
                isDrag = true;
            };

            var onMouseUp = function (e) {
                e.preventDefault();
                e.stopPropagation();
                document.removeEventListener('mousemove', mouseMove);
                document.removeEventListener('mouseup', onMouseUp);
                window.setTimeout(function () {
                    isDrag = false;
                }, 100);
            };

            if (!isTouch) {
                scrollHolder.addEventListener('mousedown', onMouseDown);
            }

            scrollHolder.addEventListener('scroll', debounce(function () {
                checkScrollStatus();
            }));
        }
    };

    function initialize() {
        if (!/^\/collections\//.test(location.pathname)) {
            return;
        }

        Mojito.utils.domReady(function () {
            sharedObject.transform(false);
        });
    }

    initialize();
})();
